import { inject as s, provide as c, computed as r, onBeforeUnmount as g } from "vue";
import { createInjectionKey as F } from "./highrise529.mjs";
const f = F("n-form-item");
function h(t, {
  defaultSize: a = "medium",
  mergedSize: o,
  mergedDisabled: i
} = {}) {
  const e = s(f, null);
  c(f, null);
  const d = r(o ? () => o(e) : () => {
    const {
      size: n
    } = t;
    if (n) return n;
    if (e) {
      const {
        mergedSize: u
      } = e;
      if (u.value !== void 0)
        return u.value;
    }
    return a;
  }), m = r(i ? () => i(e) : () => {
    const {
      disabled: n
    } = t;
    return n !== void 0 ? n : e ? e.disabled.value : !1;
  }), l = r(() => {
    const {
      status: n
    } = t;
    return n || (e == null ? void 0 : e.mergedValidationStatus.value);
  });
  return g(() => {
    e && e.restoreValidation();
  }), {
    mergedSizeRef: d,
    mergedDisabledRef: m,
    mergedStatusRef: l,
    nTriggerFormBlur() {
      e && e.handleContentBlur();
    },
    nTriggerFormChange() {
      e && e.handleContentChange();
    },
    nTriggerFormFocus() {
      e && e.handleContentFocus();
    },
    nTriggerFormInput() {
      e && e.handleContentInput();
    }
  };
}
export {
  h as default,
  f as formItemInjectionKey
};
